'use client';

import { NextErrorPage } from 'common-nextjs';
import AppDirErrorPage from '~/components/AppDir/AppDirErrorPage';

export default function DefaultErrorPage({ error, reset }: NextErrorPage) {
  return (
    <AppDirErrorPage error={error} reset={reset} title="Something went wrong" />
  );
}
